import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from 'src/app/services/account.service';
import { Observable } from 'rxjs';
import { SCAMP_API } from 'src/environments/environment';
import { UploadPhoto } from './upload-photo.model';
import { FotoBase64ViewModel } from '../../domain/viewmodels.models';


@Injectable({ providedIn: 'root' })
export class FecharOSService {

    constructor(
        private http: HttpClient,
        private account: AccountService
    ) { }


    fecharOS(data: any): Observable<any> {
        return this.http.post(`${SCAMP_API.accountApiV1}/os-fechamento-web`, data, { headers: this.account.composeHeaders() });
    }

    uploadPhotos(photos: File[], uploadPhotos: UploadPhoto[]): Observable<any> {
        const formData = new FormData();
        for (const f of photos) {
            formData.append('photos', f);
        }

        formData.append('jsonuploadphoto', JSON.stringify(uploadPhotos));

        return this.http.post(`${SCAMP_API.accountApiV1}/os-fechamento/upload/fotos/web`,
            formData, { headers: this.account.composeHeaders() });
    }


    uploadPhotos2(photos: File[], OSFechamentoId: string): Observable<any> {

        const formData = new FormData();

        for (const f of photos) {
            formData.append('photos', f);
        }

        formData.append('OSFechamentoId', OSFechamentoId);

        return this.http.post(`${SCAMP_API.accountApiV1}/os-fechamento/upload/fotos/mobil`,
            formData, { headers: this.account.composeHeaders() });
    }


    removerOSFechamentoIrregularidade(irregularidadeId: number, osFechamentoId: number) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/osfechamentoirregularidade/remove/${irregularidadeId}/${osFechamentoId}`
            , { headers: this.account.composeHeaders() });
    }

    removerOSFechamentoMovOrdemMaterial(materialId: number, osFechamentoId: number) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/osfechamentomovordemmaterial/remove/${materialId}/${osFechamentoId}`
            , { headers: this.account.composeHeaders() });
    }


    getFotoBase64(arquivoNome: any): Observable<any> {

        return this.http.post(`${SCAMP_API.accountApiV1}/fotobase64/download`,
            arquivoNome, { headers: this.account.composeHeaders() });

    }


    getArrayFotosBase64(uploadPhotos: any[]): Observable<FotoBase64ViewModel[]> {

        return this.http.post<FotoBase64ViewModel[]>(`${SCAMP_API.accountApiV1}/array-fotos-base64/download`,
        uploadPhotos, { headers: this.account.composeHeaders() });

    }
}
